import React, { useState, useEffect } from "react";
import Datatable from "../../../components/shared/datatable/Datatable";
import { EditSvg } from "../../../svgFiles/EditSvg";
import RolePermissionModal from "./RolePermissionModal";
import {
  useGetRolesWithPermissionsQuery,
  useGetPermissionsListQuery,
} from "./rolePermissionApi";
import useTranslator from "../../../hooks/useTranslator";

const RolePermission = () => {
  const { _t } = useTranslator();
  const [page, setPage] = useState(1);
  const [filter, setFilter] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [selectedRole, setSelectedRole] = useState(null);

  const {
    data: rolesWithPermissionsData,
    isLoading : isRolesAndPermissionsLoading,
    isFetching: isRolesAndPermissionsFetching,
    refetch: refetchRecord,
  } = useGetRolesWithPermissionsQuery({
    page,
    ...filter,
  });

  const {
    data: permissionsList,
    isLoading: permissionListLoading,
    isFetching: permissionListFetching,
  } = useGetPermissionsListQuery({});

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  const handleEdit = (role) => {
    console.log('handleEdit called with role:', role);
    setSelectedRole(role);
    setShowModal(true);
  };

  useEffect(() => {
    refetchRecord();
  }, [filter, refetchRecord]);

  const columns = [
    {
      label: _t("role_name", "Role Name"),
      accessor: "name",
      cell: ({ value }) => (
        <span className="fw-semibold text-capitalize">{_t(value)}</span>
      ),
    },
    {
      label: _t("role_type", "Role Type"),
      accessor: "role_type",
      cell: ({ value }) => (
        <span className={`cmn_badge ${value === "administrator" ? "" : "inactive"}`}>
          {_t(value, value)}
        </span>
      ),
    },
    {
      label: _t("edit", "Edit"),
      accessor: "actions",
      cell: ({ row }) => (
        <span 
          style={{ cursor: 'pointer' }} 
          onClick={() => {
            console.log('Edit clicked for role:', row);
            handleEdit(row);
          }}
        >
          <EditSvg />
        </span>
      ),
    },
  ];

  return (
    <div>
      {console.log('Modal state - show:', showModal, 'selectedRole:', selectedRole)}
      <RolePermissionModal
        show={showModal}
        setShow={setShowModal}
        role={selectedRole}
        permissionsList={permissionsList?.data || []}
        onUpdate={refetchRecord}
      />      
      <Datatable
        title={_t("role_permission_management", "Role Permission Management")}
        columns={columns}
        tableData={rolesWithPermissionsData?.data}
        pagination
        page={page}
        onPageChange={handlePageChange}
        showFilter={setFilter}
        showFilterButton={false}
        filterModule="role_permission"
        isLoading={isRolesAndPermissionsLoading || isRolesAndPermissionsFetching || permissionListLoading || permissionListFetching}
      />
    </div>
  );
};

export default RolePermission;